import { OWebPageBase } from "oweb";
import app from "@/app";
import PAppUpdateComponent from "@/components/pages/oweb/PAppUpdate.vue";
import { VueConstructor } from 'vue';

export default class PAppUpdate extends OWebPageBase<VueConstructor> {

	getName() {
		return 'PAppUpdate';
	}

	getRoutes() {
		return [ {
			title: "OO_LANG_APP_UPDATE",
			path: "/app/update"
		} ]
	}

	onClose() {
		let updaterData = app.ls.load("updater") || {};
		if (updaterData.force_update) {
			app.closeApp();
		}
	}

	getComponent() {
		return PAppUpdateComponent;
	}
}